module.exports = __webpack_public_path__ + "static/img/cat_sleeping.db2e17c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cat_sleeping.gif
// module id = 417
// module chunks = 1